(function() {
  /** @type {WeakMap<HTMLElement, any>} */
  const initializedCarousels = new WeakMap();
  /** @type {WeakMap<HTMLElement, ReturnType<typeof setInterval> | undefined>} */
  const autoplayIntervals = new WeakMap();

  function cleanupCarousel(carouselElement) {
    const interval = autoplayIntervals.get(carouselElement);
    if (interval) {
      clearInterval(interval);
      autoplayIntervals.delete(carouselElement);
    }
  }

  /**
   * @param {HTMLElement} carouselElement
   */
  function initCarousel(carouselElement) {
    if (!carouselElement) return;
    
    // Clean up if already initialized
    if (initializedCarousels.has(carouselElement)) {
      cleanupCarousel(carouselElement);
      initializedCarousels.delete(carouselElement);
    }

    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(() => initCarousel(carouselElement), 100);
      return;
    }

    const embla = EmblaCarousel(carouselElement, {
      loop: false,
      align: 'start',
      containScroll: 'trimSnaps',
      slidesToScroll: 1,
      dragFree: false
    });

    initializedCarousels.set(carouselElement, embla);

    // Handle window resize for responsive behavior
    /** @type {ReturnType<typeof setTimeout> | undefined} */
    let resizeTimeout;
    const handleResize = () => {
      if (resizeTimeout !== undefined) {
        clearTimeout(resizeTimeout);
      }
      resizeTimeout = setTimeout(() => {
        embla.reInit();
      }, 250);
    };

    window.addEventListener('resize', handleResize);

    // Setup autoplay
    const autoplay = carouselElement.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(carouselElement.dataset.autoplaySpeed) || 3;
    const autoplayIntervalMs = autoplaySpeed * 1000;

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      const interval = setInterval(() => {
        if (embla.canScrollNext()) {
          embla.scrollNext();
        } else {
          embla.scrollTo(0);
        }
      }, autoplayIntervalMs);
      autoplayIntervals.set(carouselElement, interval);
    }

    function stopAutoplay() {
      const interval = autoplayIntervals.get(carouselElement);
      if (interval) {
        clearInterval(interval);
        autoplayIntervals.delete(carouselElement);
      }
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (autoplay) {
      startAutoplay();

      // Pause on hover
      carouselElement.addEventListener('mouseenter', stopAutoplay);
      carouselElement.addEventListener('mouseleave', startAutoplay);

      // Reset on user interaction
      embla.on('pointerDown', resetAutoplay);
      embla.on('select', resetAutoplay);
    }
  }

  function initAllCarousels() {
    const carousels = document.querySelectorAll('.partners-slider__viewport:not([data-initialized])');
    carousels.forEach((carousel) => {
      if (carousel instanceof HTMLElement) {
        carousel.setAttribute('data-initialized', 'true');
        initCarousel(carousel);
      }
    });
  }

  function handleThemeEditorUpdates() {
    // Listen for theme editor DOM updates
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', initAllCarousels);
      document.addEventListener('shopify:section:reorder', initAllCarousels);
      document.addEventListener('shopify:block:select', initAllCarousels);
    }
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllCarousels();
      handleThemeEditorUpdates();
    });
  } else {
    initAllCarousels();
    handleThemeEditorUpdates();
  }

  // Use MutationObserver for theme editor updates
  if (window.Shopify?.designMode) {
    const observer = new MutationObserver(() => {
      initAllCarousels();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

